"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meterReadingMailboxInfoPopupPropTypes = exports.meterReadingEmailNotificationPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var meterReadingMailboxInfoPopupPropTypes = exports.meterReadingMailboxInfoPopupPropTypes = {
  headline: _propTypes.default.string.isRequired,
  subline: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  closeButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired
};
var meterReadingEmailNotificationPropTypes = exports.meterReadingEmailNotificationPropTypes = {
  fromToMetersRegisteredText: _propTypes.default.string.isRequired,
  metersRegisteredText: _propTypes.default.string.isRequired,
  headLine: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  acceptButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired,
  declineButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired,
  mailboxPopup: _propTypes.default.shape(meterReadingMailboxInfoPopupPropTypes).isRequired
};